import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 自訂語言檔
import en from './locales/en';
import zh from './locales/zh';
import pt from './locales/pt';

// 使用插件
Vue.use(VueI18n)

// 建立 VueI18n 實體

const allLang = { en, zh, pt }

const i18n = new VueI18n({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: allLang
})

export function changeLang(lang) {
  const supportedLang = Object.keys(i18n.messages);
  if (supportedLang.includes(lang)) {
    i18n.locale = lang;
  } else {
    i18n.locale = i18n.fallbackLocale;
  }

  setTitle();
}

export function getLocale() {
  return i18n.locale;
}

export function getLoacaledStr(locale, key) {
  const str = allLang[locale][key] || '';
  return str
}

export function getStr(key) {
  return getLoacaledStr(i18n.locale, key)
}


export function setTitle() {
  document.title = getStr('app_title');
  window.JsApi.Page.setTitle({ title: getStr('app_title') });

  //window.JsApi.Page.setTitleVisible(false);
  //window.JsApi.Page.setStatusBar({ fitsSystemWindows: true });

}


export default i18n